export type AppPlatform = 'ANDROID' | 'IOS';
export type UpdateType = 'REQUIRED' | 'OPTIONAL' | 'NONE';

export const PLATFORM_LABELS: Record<AppPlatform, string> = {
    ANDROID: 'Android',
    IOS: 'iOS',
};

export const UPDATE_TYPE_LABELS: Record<UpdateType, string> = {
    REQUIRED: '필수',
    OPTIONAL: '선택',
    NONE: '없음',
};

export interface AppVersionItem {
    id: number;
    platform: AppPlatform;
    versionCode: number;
    versionName: string;
    minRequiredVersionCode: number;
    updateType: UpdateType;
    updateTitle?: string;
    updateMessage?: string;
    storeUrl?: string;
    isActive: boolean;
    releasedAt: string;
    createdAt: string;
    updatedAt: string;
}

export interface CreateAppVersionRequest {
    platform: AppPlatform;
    versionCode: number;
    versionName: string;
    minRequiredVersionCode: number;
    updateType: UpdateType;
    updateTitle?: string;
    updateMessage?: string;
    storeUrl?: string;
    releasedAt: string;
}

export interface UpdateAppVersionRequest {
    versionName: string;
    minRequiredVersionCode: number;
    updateType: UpdateType;
    updateTitle?: string;
    updateMessage?: string;
    storeUrl?: string;
    isActive: boolean;
    releasedAt: string;
}

export interface AppVersionFilterParams {
    page: number;
    size: number;
    platform?: AppPlatform;
}
